import * as emails from '@/store/Email/index'
import * as activeUser from '@/store/User/index'
import * as attachmentsList from '@/store/Attachments/index'
import * as gmailApi from '@/store/Gapi/index'
import * as search from '@/store/Search/index'
import * as templatesList from '@/store/Templates/index'
import * as activeTab from '@/store/ActiveTab/index'
import * as tagList from '@/store/Tags/index'
import * as emailReportsList from '@/store/EmailReports/index'

const modules = {}

Object.assign(modules, emails.modules)
Object.assign(modules, activeUser.modules)
Object.assign(modules, attachmentsList.modules)
Object.assign(modules, gmailApi.modules)
Object.assign(modules, search.modules)
Object.assign(modules, templatesList.modules)
Object.assign(modules, activeTab.modules)
Object.assign(modules, tagList.modules)
Object.assign(modules, emailReportsList.modules)

export default modules



// WEBPACK FOOTER //
// ./src/store/storeModulesList.js